// What the Onboarding tab / overview card show for a prospect, so the rule
// lives in one tested place instead of inline conditions in ProspectDetail.

// Why a prospect has no roadmap, as the UI needs to tell it:
//   "repair"      : it is being onboarded but its roadmap is missing: the
//                   "Réparer la feuille de route" action makes sense.
//   "no_history"  : it is already an active client and no onboarding was ever
//                   recorded. Nothing to start or repair: a blank roadmap would
//                   present a finished onboarding as not done, so none is offered
//                   (backend/onboarding/service.py start_for_prospect refuses it).
//   "not_started" : anything earlier in the pipeline.
// null when a roadmap exists.
export function onboardingEmptyState(status, roadmapLength) {
  if (roadmapLength > 0) return null;
  if (status === "onboarding_in_progress") return "repair";
  if (status === "active_client") return "no_history";
  return "not_started";
}

export function onboardingSummaryLabel(status, roadmapLength, doneModules, totalModules) {
  const state = onboardingEmptyState(status, roadmapLength);
  if (state === "no_history") return "Historique non enregistré";
  if (state) return "Non démarré";
  return `${doneModules} / ${totalModules} modules terminés`;
}
